module.exports = __webpack_public_path__ + "assets/img/16.789a5c96.png";